<template>
  <div class="timescard-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Select v-model="formItem.is_through_ticket" clearable filterable placeholder="是否通票...">
              <Option v-for="item in payStatusList" :value="item.id" :key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createOrUpdate('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="选择园区">
          <Select v-model="dataInfo.smarkpark_id" filterable clearable @on-change="smarkparkChange">
            <Option v-for="item in smarkparkList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="选择场馆" v-if="Venue">
          <Select v-model="dataInfo.venue_id" filterable clearable>
            <Option v-for="item in venueList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称" prop="name">
          <Input v-model="dataInfo.name" placeholder="请输入名称..."></Input>
        </FormItem>
        <FormItem label="次数" prop="times">
          <Input v-model="dataInfo.times"></Input>
        </FormItem>
        <FormItem label="价格" prop="price">
          <Input v-model="dataInfo.price"></Input>
        </FormItem>
        <FormItem label="是否通票" label-position="top">
          <RadioGroup v-model="dataInfo.is_through_ticket" @on-change="isthrough">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "timescard-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      Venue: true,
      thumblist: [],
      venueList: [],
      smarkparkList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      payStatusList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "是否通票",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.is_through_ticket == 1 ? "是" : "否")
            ]);
          }
        },
        {
          title: "名称",
          key: "name",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.venue_id == 0
                  ? params.row.name
                  : params.row.name + "  [" + params.row.venue.title + "]"
              )
            ]);
          }
        },
        {
          title: "状态",
          key: "status",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        name: "",
        times: "",
        price: "",
        venue_id: 0,
        is_through_ticket: 0
      },
      showModalStatus: false,
      dataInfoValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      }
    };
  },
  // 组件
  components: {},
  created: function() {
    this.$api.smartpark
      .list({
        page: 1,
        size: 100
      })
      .then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.smarkparkList = res.result.list;
        }
      });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartTimesCard
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    smarkparkChange(value) {
      if (value != undefined) {
        this.$api.smartvenue
          .list({ size: 9999, smarkpark_id: value })
          .then(res => {
            if (res.code == 200) {
              this.venueList = res.result.list;
            }
          });
      }
    },
    isthrough: function(val) {
      // 返回的是 lable值
      if (val == "0") {
        this.Venue = true;
      } else if (val == "1") {
        this.Venue = false;
      }
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.Venue = true;
      this.dataInfo = {
        name: "",
        times: "",
        price: "",
        venue_id: 0,
        is_through_ticket: 0
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        name: "",
        times: "",
        price: "",
        venue_id: 0,
        is_through_ticket: 0
      };
      this.showModalStatus = !this.showModalStatus;
      this.$api.smartTimesCard.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        //切换头条展示形式
        if (this.dataInfo.is_through_ticket == "0") {
          this.Venue = true;
        } else if (this.dataInfo.is_through_ticket == "1") {
          this.Venue = false;
        }
      });
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.smartTimesCard.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.smartTimesCard.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartTimesCard.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function(index, value) {
      var status = value == true ? 1 : 0;
      this.$api.smartTimesCard
        .status({ id: index, status: status })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
        });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        is_through_ticket: this.formItem.is_through_ticket,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.smartTimesCard.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>